import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SelectProductStepButton } from "./SelectProductStepButton/SelectProductStepButton";
import { useCallback } from "react";
import { navigateToPolicyStep, NewPolicyRoutes } from "@routing/paths";
import { useNavigate } from "react-router";
import { useAppDispatch } from "@redux/hooks";
import {
  resetPersonalDetails,
  resetPolicy,
  resetUnitConstructionAndDetails,
  selectOwnershipType,
  setOwnershipType,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { OwnershipType } from "@covertree/types";
import { featureFlags } from "@utils/featureFlags";

export function SelectProductStep() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ownershipType = useNewBusinessSelector(selectOwnershipType);
  const landlordQuotesEnabled = featureFlags.landlordQuotesEnabled.isEnabled();

  const onSubmit = useCallback(
    (newOwnershipType: OwnershipType) => {
      if (newOwnershipType !== ownershipType) {
        dispatch(resetPolicy());
        dispatch(resetUnitConstructionAndDetails());
        dispatch(resetPersonalDetails());
      }
      dispatch(setOwnershipType(newOwnershipType));

      navigateToPolicyStep(
        navigate,
        newOwnershipType === OwnershipType.Landlord
          ? NewPolicyRoutes.UNIT_COUNT
          : NewPolicyRoutes.HOME_ADDRESS,
        NewPolicyRoutes.SELECT_PRODUCT
      );
    },
    [navigate, dispatch]
  );

  return (
    <>
      <Typography variant="h4">Select a product</Typography>

      <Box mt={4}>
        <Box>
          <SelectProductStepButton
            onClick={() => onSubmit(OwnershipType.Resident)}
            icon="/images/card-icons/resident.webp"
            title="Manufactured Homeowners/Renters"
          />
        </Box>

        <Box mt={3}>
          <SelectProductStepButton
            onClick={() => onSubmit(OwnershipType.Landlord)}
            icon="/images/card-icons/landlord.webp"
            title="Manufactured Landlord"
            {...(!landlordQuotesEnabled
              ? { disabled: true, subtitle: "Coming Soon" }
              : {})}
          />
        </Box>

        <Box mt={3}>
          <SelectProductStepButton
            disabled
            icon="/images/plan-icons/water.webp"
            title="Flood"
            subtitle="Coming Soon"
          />
        </Box>
      </Box>
    </>
  );
}
